import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store, persistor } from "./store/index";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import "./components/styles/variables.css";
import "./index.css";
import ErrorBoundaryView from "components/ErrorBoundaryView";
import "intersection-observer";
import { isAuthenticated } from "./services/Auth";
import { apiMain } from "./services";

Error.stackTraceLimit = 1000;

Bugsnag.start({
  apiKey: process.env.REACT_APP_BUGSNAG_API_KEY ?? "",
  appVersion: process.env.REACT_APP_VERSION ?? "dev",
  releaseStage: process.env.REACT_APP_ENV ?? "development",
  enabledReleaseStages: ["production", "staging"],
  plugins: [new BugsnagPluginReact()],
  onError: async (event) => {
    const errors = event.errors;
    const stacktrace = errors[0].stacktrace;

    event.addMetadata("errors", errors);

    if ((await isAuthenticated())) {
      const user = await apiMain.getMe();
      event.setUser(user.username);
    }

    const isExternalError = stacktrace.find(({ file }) => {
      return !file.startsWith(`${window.location.origin}/static/js/`);
    });

    return !isExternalError;
  },
});

// @ts-ignore
const ErrorBoundary = Bugsnag.getPlugin("react").createErrorBoundary(React);

const root = createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <ErrorBoundary FallbackComponent={ErrorBoundaryView}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
